/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box, Container, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { styleguideViewStyle } from "@/src/styleguide/components/StyleguideView/styleguideViewStyle.ts";

export type StyleguideViewProps = {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  dark?: boolean;
  fullWidth?: boolean;
};

export default function StyleguideView({ children, title, subtitle, dark, fullWidth }: StyleguideViewProps) {
  return (
    <>
      <Stack sx={{ justifyContent: "center" }} direction={"row"} spacing={"0.25rem"}>
        <Container disableGutters={!fullWidth}>
          {!!title && (
            <Typography component={"strong"} variant={"h6"}>
              {title}
            </Typography>
          )}
          {!!subtitle && (
            <Typography variant={"body2"} sx={{ opacity: 0.75 }}>
              {subtitle}
            </Typography>
          )}
        </Container>
      </Stack>
      <Box
        sx={mergeSx(
          styleguideViewStyle.content,
          fullWidth && styleguideViewStyle.contentFullWidth,
          dark &&
            ((theme) => ({
              backgroundColor: theme.palette.common.black,
            })),
        )}
      >
        {children}
      </Box>
    </>
  );
}
